class MainNav {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.init();
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    const menu = document.querySelector(".menu");
    const menuOverlay = document.querySelector(".menu-overlay");
    const languageSwitch = document.getElementById("language-switch--js");
    if (!menu) {
      return;
    }

    if (languageSwitch) {
      const currentLocaleUrl = languageSwitch.value;
      // Arrow keys move through the options in some browsers without opening the
      // listbox, so navigating on every change would be an unexpected context
      // change (WCAG 3.2.2). Defer to Enter or leaving the field in that case.
      let isBrowsingByKeyboard = false;

      const goToSelectedLocale = () => {
        if (languageSwitch.value && languageSwitch.value !== currentLocaleUrl) {
          location.href = languageSwitch.value;
        }
      };

      languageSwitch.addEventListener("keydown", (event) => {
        if (event.key.startsWith("Arrow")) {
          isBrowsingByKeyboard = true;
        } else if (event.key === "Enter") {
          isBrowsingByKeyboard = false;
          goToSelectedLocale();
        } else if (event.key === "Escape") {
          isBrowsingByKeyboard = false;
        }
      });

      languageSwitch.addEventListener("change", () => {
        if (!isBrowsingByKeyboard) {
          goToSelectedLocale();
        }
      });

      languageSwitch.addEventListener("blur", () => {
        isBrowsingByKeyboard = false;
        goToSelectedLocale();
      });
    }

    const goBack = menu.querySelector(".go-back");
    const menuTrigger = document.querySelector(".mobile-menu-trigger");
    const closeMenu = menu.querySelector(".mobile-menu-close");
    const parentLinks = menu.querySelectorAll(
      ".menu-item-has-children > .lvl-1",
    );
    let subMenu;

    parentLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        const hasChildren = link.closest(".menu-item-has-children");
        if (!hasChildren) {
          return;
        }

        if (window.innerWidth <= 991 && menu.classList.contains("active")) {
          event.preventDefault();
          showSubMenu(hasChildren);
          return;
        }

        if (window.innerWidth > 991) {
          event.preventDefault();
          toggleDesktopSubMenu(hasChildren);
        }
      });
    });

    goBack.addEventListener("click", () => {
      hideSubMenu();
    });
    menuTrigger.addEventListener("click", () => {
      toggleMenu();
    });
    closeMenu.addEventListener("click", () => {
      toggleMenu();
    });
    menuOverlay.addEventListener("click", () => {
      toggleMenu();
    });

    document.addEventListener("click", (event) => {
      if (window.innerWidth <= 991) {
        return;
      }

      if (!event.target.closest(".menu-row")) {
        closeDesktopSubMenus();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeDesktopSubMenus();

        if (menu.classList.contains("active")) {
          toggleMenu();
        }
      }
    });

    function toggleMenu() {
      menu.classList.toggle("active");
      menuOverlay.classList.toggle("active");

      if (!menu.classList.contains("active")) {
        document.body.style.position = "";
        document.body.style.top = "";
        if (subMenu) {
          hideSubMenu(true);
        }
      } else {
        document.body.style.position = "fixed";
        document.body.style.top = `-${window.scrollY}px`;
      }
    }

    function toggleDesktopSubMenu(menuItem) {
      const isOpen = menuItem.classList.contains("is-open");
      closeDesktopSubMenus();

      if (!isOpen) {
        menuItem.classList.add("is-open");
        const parentLink = menuItem.querySelector(".lvl-1");
        if (parentLink) {
          parentLink.setAttribute("aria-expanded", "true");
        }
      }
    }

    function closeDesktopSubMenus() {
      menu
        .querySelectorAll(".menu-item-has-children.is-open")
        .forEach((item) => {
          item.classList.remove("is-open");
          const parentLink = item.querySelector(".lvl-1");
          if (parentLink) {
            parentLink.setAttribute("aria-expanded", "false");
          }
        });
    }

    function showSubMenu(hasChildren) {
      let areaLink = document.createElement("a");
      areaLink.innerHTML = hasChildren.firstElementChild.innerHTML;
      areaLink.setAttribute("href", hasChildren.firstElementChild.href);
      areaLink.classList.add("area-link");

      subMenu = hasChildren.querySelector(".sub-menu");
      subMenu.classList.add("active");
      subMenu.style.animation = "slideLeft 0.5s ease forwards";
      menu.querySelector(".current-menu-title").append(areaLink);
      menu.querySelector(".mobile-menu-head").classList.add("active");
    }

    function hideSubMenu(skipAnimation = false) {
      if (!subMenu) {
        return;
      }

      if (skipAnimation) {
        subMenu.classList.remove("active");
      } else {
        subMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
          subMenu.classList.remove("active");
        }, 300);
      }

      const currentTitleLink = menu.querySelector(".current-menu-title a");
      if (currentTitleLink) {
        currentTitleLink.remove();
      }

      menu.querySelector(".mobile-menu-head").classList.remove("active");
      subMenu = null;
    }

    window.onresize = function () {
      if (this.innerWidth > 991) {
        if (menu.classList.contains("active")) {
          toggleMenu();
        }

        closeDesktopSubMenus();
      }
    };
  }
}

export default MainNav;
